"use client";
import Link from "next/link";

export default function Error({ reset }: { error: Error; reset: () => void }) {
  return (
    <div className="container section-padding text-center py-24">
      <p className="text-6xl mb-4">⚠️</p>
      <h1 className="text-2xl font-bold text-[var(--color-text-dark)] mb-2">
        오류가 발생했습니다
      </h1>
      <p className="text-[var(--color-text-light)] mb-8">
        일시적인 오류입니다. 잠시 후 다시 시도해주세요.
      </p>
      <div className="flex gap-3 justify-center">
        <button onClick={reset} className="btn-primary">
          다시 시도
        </button>
        <Link href="/" className="btn-outline inline-flex">
          홈으로
        </Link>
      </div>
    </div>
  );
}
